var _circle, _path, _path2, _path3, _circle2, _path4, _path5, _circle3, _path6, _path7, _circle4, _path8, _path9, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: "100px",
    height: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 66,
    r: 3,
    fill: "#f9e65c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70,19H31c-6.6,0-12,5.4-12,12v39c0,6.6,5.4,12,12,12h39c6.6,0,12-5.4,12-12V31 C82,24.4,76.6,19,70,19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M70,82.988H31c-7.18,0-13-5.82-13-13v-39c0-7.18,5.82-13,13-13h39c7.18,0,13,5.82,13,13v39 C83,77.168,77.179,82.988,70,82.988z M20,30.988v39c0,6.075,4.925,11,11,11h39c6.075,0,11-4.925,11-11v-39c0-6.075-4.925-11-11-11 H31C24.924,19.988,20,24.913,20,30.988z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M67.148,77.988H33.823c-5.985,0-10.837-4.852-10.837-10.837V33.825 c0-5.985,4.852-10.837,10.837-10.837h33.663c0.276,0,0.5,0.224,0.5,0.5s-0.224,0.5-0.5,0.5H33.823 c-5.433,0-9.837,4.404-9.837,9.837V67.15c0,5.433,4.405,9.838,9.838,9.838h33.325c5.433,0,9.837-4.404,9.837-9.837V48.488 c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5V67.15C77.986,73.136,73.133,77.988,67.148,77.988z M77.486,45.567 c-0.276,0-0.5-0.224-0.5-0.5v-4c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v4C77.986,45.344,77.762,45.567,77.486,45.567z M77.486,39.567c-0.276,0-0.5-0.224-0.5-0.5v-2c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2 C77.986,39.344,77.762,39.567,77.486,39.567z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 50,
    r: 3,
    fill: "#f15b6c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M35,48c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2S33.897,48,35,48 M35,47c-1.657,0-3,1.343-3,3 s1.343,3,3,3s3-1.343,3-3S36.657,47,35,47L35,47z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M35,44.501 c-3.032,0-5.499,2.467-5.499,5.499s2.467,5.499,5.499,5.499s5.499-2.467,5.499-5.499S38.032,44.501,35,44.501z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 34,
    r: 3,
    fill: "#78a2d2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M35,32c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2S33.897,32,35,32 M35,31c-1.657,0-3,1.343-3,3 s1.343,3,3,3s3-1.343,3-3S36.657,31,35,31L35,31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M35,28.508 c-3.028,0-5.492,2.464-5.492,5.492s2.464,5.492,5.492,5.492s5.492-2.464,5.492-5.492S38.028,28.508,35,28.508z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 66,
    r: 3,
    fill: "#f9e65c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M35,60.508 c-3.028,0-5.492,2.464-5.492,5.492c0,3.028,2.464,5.492,5.492,5.492s5.492-2.464,5.492-5.492 C40.492,62.972,38.028,60.508,35,60.508z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f212b",
    d: "M35,69c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S36.654,69,35,69z M35,64 c-1.103,0-2,0.897-2,2s0.897,2,2,2s2-0.897,2-2S36.103,64,35,64z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    x2: 71.5,
    y1: 34.5,
    y2: 34.5,
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    x2: 71.5,
    y1: 50.5,
    y2: 50.5,
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    x2: 71.5,
    y1: 66.5,
    y2: 66.5,
    fill: "none",
    stroke: "#1f212b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApp);
export default __webpack_public_path__ + "static/media/app.265debdcb9a3e9e813ed099045f2822e.svg";
export { ForwardRef as ReactComponent };